module.exports = __webpack_public_path__ + "static/media/cpt.f256947d.svg";